// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-area .nav-tabs{padding-right:0!important}", ""]);
// Exports
module.exports = exports;
